import { render, staticRenderFns } from "./NewPromo.vue?vue&type=template&id=2cbfbc96&scoped=true&"
import script from "./NewPromo.vue?vue&type=script&lang=js&"
export * from "./NewPromo.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./NewPromo.vue?vue&type=style&index=1&id=2cbfbc96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbfbc96",
  null
  
)

export default component.exports